import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import '../styles/ProductGallery.css';
import ResponsiveImage from './ResponsiveImage';
import ParallaxModel from './ParallaxModal';
import ZoomableImageWithLens from './ZoomableImageWithLens';
import AppContext from './context/AppContext';
import Product3DModelThumbnail from './Product3DModelThumbnail';

const ProductGallery = ({ images = [], product, models = [] }) => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeModelIndex, setActiveModelIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isImage, setIsImage] = useState(true);
    const [isModel, setIsModel] = useState(false);
    // show modal on image Click
    const handleImageClick = () => {
        setShowModal(true);
    };

    // Cancel model on click outside
    const cancelModel = () => {
        setShowModal(false);
        handleImageSelect(0);
    };
    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    const imagesWithUrl = images.filter(
        (image) => typeof image.url === 'string' && image.url !== '',
    );

    const handleModelSelect = (index) => {
        setActiveModelIndex(index);
        setIsModel(true);
        setIsImage(false);
        setShowModal(true);
    };

    const handleImageSelect = (index) => {
        setActiveIndex(index);
        setIsImage(true);
        setIsModel(false);
    };

    /** @todo Add "click to expand" feature. */
    return <section
        className={'product-gallery--container'}>
        {/** @todo Load all images in a div. */}
        {/** @todo Switch image position instead of changing the src. */}
        <ParallaxModel
            show={showModal}
            index={activeIndex}
            onClose={cancelModel}
            onClick={stopPropagation}
            productTitle={product.title}
            images={images}
            isImage={isImage}
            isModel={isModel}
            models={models}
            modelIndex={activeModelIndex}
        />
        <div
            className={'product-gallery--navigation'}>
            {imagesWithUrl.map((image, index) => <button
                key={index}
                className={`product-gallery--thumbnail-button${activeIndex === index ? ' active' : ''}`}
                onClick={() => handleImageSelect(index)}
            >
                <ResponsiveImage
                    imageUrl={image.url}
                    imageAlt={image.altText || ''}
                    mobileSize={'75px'}
                    desktopSize={'75px'}
                />
            </button>)}
            {models.map((model, index) => <Product3DModelThumbnail
                index={index}
                key={index}
                onClick={handleModelSelect}
                model={model} />)}
        </div>

        <div
            className={'product-gallery--viewer'}>
            {imagesWithUrl.length < 1 ? (
                <ZoomableImageWithLens
                    imageUrl={appConfig.productNoImageUrl}
                    imageAlt={'No product image'}
                />
            ) : (
                <ZoomableImageWithLens
                    imageUrl={imagesWithUrl[activeIndex].url}
                    imageAlt={imagesWithUrl[activeIndex].altText || ''}
                    onClick={handleImageClick}
                />
            )}
        </div>

    </section>;
};

ProductGallery.propTypes = {
    product: PropTypes.shape({
        title: PropTypes.string,
        Images: PropTypes.array,
    }),
    onImageClick: PropTypes.func,
    images: PropTypes.arrayOf(PropTypes.shape({
        altText: PropTypes.string,
        Attachment: PropTypes.shape({
            localPath: PropTypes.string.isRequired,
        }),
    })),
    models: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        posterUrl: PropTypes.string,
        url: PropTypes.string,
    })),
};

export default ProductGallery;